import { createContext } from "react";
import { PermissionContextState } from './permission.type';

export const PermissionContext = createContext<PermissionContextState>({} as PermissionContextState);
